import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import SyncConstants from "../../constants/SyncConstants";
import useAuthentication from "../../hooks/useAuthentication";

const PendingBillingIndicator = () => {
    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const CurrentUser = useSelector((state) => state.CurrentUser);
    const Auth = useAuthentication();

    useEffect(() => {
        // Nur für Admins laden
        if (!CurrentUser.data || CurrentUser.data.role !== 'administrator') {
            setLoading(false);
            return;
        }

        loadCount();

        // Alle 5 Minuten aktualisieren
        const interval = setInterval(loadCount, 5 * 60 * 1000);
        
        return () => clearInterval(interval);
    }, [CurrentUser.data]);

    const loadCount = () => {
        axios({
            method: 'GET',
            url: SyncConstants.syncBaseURL + 'expenseEntries/pendingBillingCount',
            auth: Auth.getAuthObject()
        }).then(response => {
            setCount(response.data.count || 0);
            setLoading(false);
        }).catch(error => {
            console.error('Fehler beim Laden der Abrechnungsstatistik:', error);
            setLoading(false);
        });
    };

    // Nichts anzeigen wenn kein Admin oder keine offenen Abrechnungen
    if (!CurrentUser.data || CurrentUser.data.role !== 'administrator' || loading || count === 0) {
        return null;
    }

    return (
        <span 
            className="badge bg-danger rounded-pill ms-2"
            title={`${count} Projekt${count !== 1 ? 'e' : ''} mit offenen Abrechnungen aus Vormonaten`}
            style={{
                fontSize: '0.7rem',
                padding: '0.25rem 0.5rem',
                verticalAlign: 'middle'
            }}
        >
            {count}
        </span>
    );
};

export default PendingBillingIndicator;
